module.exports = __webpack_public_path__ + "static/media/城市配送_11.f530eadb.jpg";